import 'angular';

import { InvoiceItemsCtrl } from './invoice-items';

angular.module('workshop.invoiceItems', [])

.controller('InvoiceItemsCtrl', InvoiceItemsCtrl);